/* Native disclosure animation is progressive enhancement. No purchase API is replaced. */
document.addEventListener('click', function (event) {
  var link = event.target.closest('a[href="#kan-usage"]');
  if (!link) return;
  var steps = document.querySelector('[data-kan-section="kan-steps"]');
  if (!steps) return;
  event.preventDefault();
  steps.scrollIntoView({behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'});
  steps.setAttribute('tabindex','-1');
  steps.focus({preventScroll:true});
});

/* ==========================================================================
   CART TOAST

   With the cart drawer off, an AJAX add-to-cart changed nothing a shopper
   could see except the header bubble. This listens for the same event the
   header listens to and confirms the add where the shopper is already
   looking, with the next step attached.

   `shopify:cart:lines-update` is the Standard Events name (StandardEvents
   .cartLinesUpdate). It is referenced as a string rather than imported
   because this file is a classic deferred script, not a module. The event
   bubbles from product-form-component up to document, and carries a promise
   that resolves once the cart has actually been re-fetched — so the toast can
   name the product and never claims success before the server agreed.
   ========================================================================== */
(function () {
  var HIDE_AFTER = 6000;

  var toast = document.querySelector('[data-kan-toast]');
  if (!toast) return;

  var titleEl = toast.querySelector('[data-kan-toast-title]');
  var itemEl = toast.querySelector('[data-kan-toast-item]');
  var thumbEl = toast.querySelector('[data-kan-toast-thumb]');
  var closeEl = toast.querySelector('[data-kan-toast-close]');
  var defaultTitle = titleEl ? titleEl.textContent : '';
  var timer = 0;

  function clearTimer() {
    if (timer) clearTimeout(timer);
    timer = 0;
  }

  function hide() {
    clearTimer();
    toast.classList.remove('is-on');
    /* Wait out the slide-away before removing it from the a11y tree, so the
       transition is not cut short by display:none. */
    timer = setTimeout(function () {
      toast.hidden = true;
    }, 300);
  }

  function arm() {
    clearTimer();
    timer = setTimeout(hide, HIDE_AFTER);
  }

  function show() {
    toast.hidden = false;
    /* Force a reflow so the browser sees the hidden->visible state change as
       two frames and actually runs the transition. */
    void toast.offsetWidth;
    toast.classList.add('is-on');
    arm();
  }

  if (closeEl) closeEl.addEventListener('click', hide);

  /* Hovering or tabbing into the toast means the shopper is reading it — do
     not pull it away mid-read. */
  toast.addEventListener('mouseenter', clearTimer);
  toast.addEventListener('focusin', clearTimer);
  toast.addEventListener('mouseleave', arm);
  toast.addEventListener('focusout', arm);

  document.addEventListener('shopify:cart:lines-update', function (event) {
    if (!event.promise) return;

    event.promise
      .then(function (payload) {
        var detail = (payload && payload.detail) || {};

        /* The same event fires for failed adds; product-form already surfaces
           the error inline, so stay quiet rather than claim a success. */
        if (detail.didError) return;

        var items = detail.items || [];
        var productId = detail.productId != null ? String(detail.productId) : '';
        var line = null;

        for (var i = 0; i < items.length; i++) {
          if (String(items[i].product_id) === productId) {
            line = items[i];
            break;
          }
        }
        if (!line) line = items[items.length - 1];

        if (titleEl) titleEl.textContent = defaultTitle;

        if (itemEl) {
          var qty = Number(detail.itemCount) || 0;
          var name = line ? line.product_title || line.title || '' : '';
          /* The quantity is only worth stating when it is not the obvious 1. */
          itemEl.textContent = qty > 1 ? name + ' × ' + qty : name;
        }

        if (thumbEl) {
          var img = line && line.image;
          if (img) {
            thumbEl.src = img;
            thumbEl.hidden = false;
          } else {
            thumbEl.removeAttribute('src');
            thumbEl.hidden = true;
          }
        }

        show();
      })
      .catch(function () {
        /* An aborted or rejected add is not a success; product-form owns the
           error message. */
      });
  });
})();
